import type { Step } from "../script";

export const worstOffenders: Step[] = [
  {
    kind: "msg",
    id: "msg-01b-a",
    tokens:
      "where the vamp comes from: dating (mcc 7273) + health (5122). ~60% of fraud volume, 27% of subs.",
    pauseAfter: 1100,
  },
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "cohort", filter: "Warning" },
    pauseAfter: 1300,
  },
  {
    kind: "msg",
    id: "msg-01b-b",
    tokens:
      "three names carry most of it: sparkconnect, matchmoment, purederm. watch corewellness + vitalblend next.",
    pauseAfter: 1400,
  },
];
